import axios from 'axios';
import { setAlert } from './alert';

import {
  LOGIN_VS_SUCCESS,
  LOGIN_VS_FAIL,
  LOGOUT_VS,
  GET_INSTANCE,
  INSTANCE_ERROR,
  DELETE_INSTANCE
} from './types';

export const loginVirtualScreen = (code, emailUser) => async (dispatch) => {
  const body = { code: code, email: emailUser };
  try {
    const res = await axios.post('/api/supportaccess/login', body);

    dispatch({
      type: LOGIN_VS_SUCCESS,
      payload: res.data
    });
    return res;
  } catch (err) {
    dispatch({ type: LOGIN_VS_FAIL });
    return { status: err.response?.status };
  }
};

// Logout
export const logoutVS = (name, id) => async (dispatch) => {
  const body = { name: name, id: id };
  try {
    const res = await axios.post('/api/supportaccess/logout', body);

    dispatch({ type: LOGOUT_VS });
    // await axios.delete(`/api/supportaccess/instance/${id}`);
    dispatch({ type: DELETE_INSTANCE });
    return res;
  } catch (err) {
    console.error('Erreur lors de la déconnexion', err);
    dispatch(
      setAlert('Une erreur est survenue lors de la déconnexion.', 'danger')
    );
  }
};

export const getInstanceById = (instanceId) => async (dispatch) => {
  try {
    const res = await axios.get(`/api/supportaccess/instance/${instanceId}`);

    dispatch({
      type: GET_INSTANCE,
      payload: res.data
    });
  } catch (err) {
    dispatch({
      type: INSTANCE_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status }
    });
  }
};

export const updateInstanceExpirationDate =
  (instanceId) => async (dispatch) => {
    try {
      await axios.post(`/api/supportaccess/updateInstanceDate/${instanceId}`);
    } catch (err) {
      dispatch({
        type: INSTANCE_ERROR,
        payload: { msg: err.response.statusText, status: err.response.status }
      });
    }
  };
